// ==========================================
// Edge tab (4a)
// ==========================================
// The alternative collapsed state: a 34px tab welded to the viewport edge with BB,
// a vertical XP bar and a pending count. Hover peeks, click opens.
// ==========================================

import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';

import { BbState, GrowthStage, PanelEdge } from '../models/buddy.types';

@Component({
  selector: 'app-buddy-edge-tab',
  standalone: false,
  templateUrl: './buddy-edge-tab.component.html',
  styleUrls: ['./buddy-edge-tab.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BuddyEdgeTabComponent {
  @Input() bbState: BbState = 'idle';
  @Input() stage: GrowthStage = 'scout';
  @Input() xpPct = 0;
  @Input() pendingCount = 0;
  @Input() edge: PanelEdge = 'right';

  @Output() opened = new EventEmitter<void>();
}
